import { PageHeader } from "@/components/page-header/PageHeader";
import { PageLayout } from "@/components/page-layout/PageLayout";
import { ExpectedVolumeForm } from "@/features/rebates/components/ExpectedVolumeFormModal";
import { Card, stenaTags } from "@stenajs-webui/elements";
import { useCallback, useState } from "react";
import { Helmet } from "react-helmet";
import { RebatesFilterProvider } from "../../features/rebates/components/rebates-filter/RebatesFilterContext";
import { RebateProgress } from "@/gql/graphql";
import { RebateFollowUpView } from "@/features/rebates/components/RebateFollowUpView";
import { useUpdateGoalExpectedVolume } from "@/features/rebates/hooks/UseUpdateGoalExpectedVolume";
import { OPEN_REBATE } from "@/types/claims/constants";
import { hasClaim } from "@/lib/claims/utils";
import { useSelector } from "react-redux";
import { profileSelectors } from "@/redux/profile/selectors";
import { UnAuthorizedView } from "@/components/unauthorized-view/UnAuthorizedView";

export const Rebates = () => {
  const { claims } = useSelector(profileSelectors.getGlobal);
  const [editing, setEditing] = useState(false);
  const [rebateToEdit, setRebateToEdit] = useState<
    RebateProgress | undefined
  >();

  const { updateGoalExpectedVolume, loading: isUpdatingExpectedVolume } =
    useUpdateGoalExpectedVolume();

  const onEdit = useCallback((rebateProgress: RebateProgress) => {
    setRebateToEdit(rebateProgress);
    setEditing(true);
  }, []);

  const onModalClose = useCallback(() => {
    setEditing(false);
    setRebateToEdit(undefined);
  }, []);

  const onUpdateGoalExpectedVolume = useCallback(
    async (goalId: string, expectedVolume: number) => {
      if (expectedVolume && goalId) {
        await updateGoalExpectedVolume({ expectedVolume, goalId });
        onModalClose();
      }
    },
    [updateGoalExpectedVolume, onModalClose]
  );

  return (
    <>
      <Helmet title="Rebates - FPP" />

      {hasClaim(claims, [OPEN_REBATE]) ? (
        <>
          <PageHeader title="Rebates - Follow up" icon={stenaTags} />
          {editing && (
            <ExpectedVolumeForm
              isOpen={editing}
              rebate={rebateToEdit}
              onDone={onModalClose}
              onSave={onUpdateGoalExpectedVolume}
              loading={isUpdatingExpectedVolume}
            />
          )}
          <PageLayout>
            <Card>
              <RebatesFilterProvider>
                <RebateFollowUpView onEdit={onEdit} />
              </RebatesFilterProvider>
            </Card>
          </PageLayout>
        </>
      ) : (
        <UnAuthorizedView />
      )}
    </>
  );
};
